export default {
  compareYears: 'Compare years',
  granularity: 'Granularity',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  weekly: 'Weekly'
}
